import _join from 'lodash/join';
import _compact from 'lodash/compact';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import priceCodeReader from '@tekion/tekion-base/readers/PriceCode';
var getOptionLabel = function getOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var data = option.data;
  var code = priceCodeReader.code(data);
  var description = priceCodeReader.description(data);
  return _join(_compact([code, description]), ' | ');
};
var getOptionValue = priceCodeReader.id;
var PRICE_CODE_CONFIG = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};
export default PRICE_CODE_CONFIG;